<script>
    import WPNGeneralTable from "./WPNGeneralTable.svelte";
    import dbData from "../../Stores/utilityDBStore.js";
    import { personnelDataForWorkItem } from "../../scripts/wpn2DB.js";

    export let item;
    let personnelData;  // = [[{ key: "name", title: "Name", value: "JD" }]];

    $: personnelData = personnelDataForWorkItem(item, $dbData.all);
</script>

{#if personnelData.length > 0}
    <div class="detail-section">
        <div class="detail-section-title">Personnel</div>
        <div class="table-container">
            <WPNGeneralTable
                tableData={personnelData}
                on:item-edit
                on:item-add
            />
        </div>
    </div>
{/if}
